import React,{useEffect} from "react";
import pay from "../assets/pricing.png";
import styles from "../styles/Pricing.module.css";
import view from "../assets/Image item.png";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Pricing = () => {
    const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return (
    <div>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <Header />
        </div>

        <section className={styles.hero}>
          <div className={styles.heroLeft}>
            <h1 style={{fontSize:"30px"}} className={styles.head1}>
              Accept both 
              International & <br />
              Domestic Payments
            </h1>
            <p style={{fontSize:"24px"}}>
              Seamless system for both International & <br />
              Domestic Payments With a simple, flat fee!
            </p>
            {/* <button className={styles.createAccountButton}>
              Create an account
            </button> */}
          </div>
          <div className={styles.heroRight}>
            <img
              src={pay}
              alt="Payment Devices"
              className={styles.devicesImage}
            />
          </div>
        </section>

        <h2 className={styles.sectionTitle}>
          International and Local Payments
        </h2>
        <section className={styles.internationalPaymentsSection}>
          <div className={styles.paymentDetails}>
            <div className={styles.leftContent}>
              <h2>International Payments</h2>
              <ul className={styles.paymentList}>
                <p style={{ fontSize: "16px" }}>
                  <li>
                    <span styles={{ font: "12px" }} className={styles.icon}>
                      ✦
                    </span>{" "}
                    VISA
                  </li>
                  <li>
                    <span className={styles.icon}>✦</span> Mastercard
                  </li>
                  <li>
                    <span className={styles.icon}>✦</span> PayPal
                  </li>
                </p>
              </ul>
            </div>
            <div className={styles.separatorVertical}></div>
            <div className={styles.rightContent}>
              <div className={styles.priceTag}>-0% per transaction</div>
              <p className={styles.currencies}>EUR, USD, GBP, and more</p>
            </div>
          </div>
        </section>

        <section className={styles.domesticPaymentsSection}>
          <div className={styles.paymentBox}>
            <div className={styles.leftContent}>
              <h2>Domestic Payments</h2>
              <ul className={styles.paymentList}>
                <p style={{ fontSize: "16px" }}>
                  <li>
                    <span className={styles.icon}>✦</span> Local Banks
                  </li>
                  <li>
                    <span className={styles.icon}>✦</span> Wallets
                  </li>
                  <li>
                    <span className={styles.icon}>✦</span> QR Payments
                  </li>
                </p>
              </ul>
            </div>
            <div className={styles.separatorVertical}></div>
            <div className={styles.rightContent}>
              <div className={styles.priceTag}>-2.8% per transaction</div>
              <p className={styles.currencies}>ETB</p>
            </div>
          </div>
        </section>

        <section className={styles.domesticPaymentsSection}>
          <div className={styles.paymentBox}>
            <div className={styles.leftContent}>
              <h2>QR Payments - Simple & Affordable</h2>
              <p style={{ color: "black", fontSize: "1.2em" }}>
                Accept payments instantly with Arifpay QR!
              </p>

              <ul className={styles.paymentList}>
                <p style={{ fontSize: "16px" }}>
                  <li>
                    <span className={styles.icon}>✦</span>No setup fees
                  </li>
                  <li>
                    <span className={styles.icon}>✦</span> No monthly charges
                  </li>
                  <li>
                    <span className={styles.icon}>✦</span> Fast, secure, and
                    hassle-free payments for businesses of all sizes!
                  </li>
                </p>
              </ul>
            </div>
            <div className={styles.separatorVertical}></div>
            <div className={styles.rightContent}>
              <div className={styles.priceTag}>
                -2.8% per transaction
              </div>
              <p className={styles.currencies}>ETB</p>
            </div>
          </div>
        </section>
      </div>

      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 10px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "2em",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                It Starts With Your Business
                <br />
                Account
              </h2>
              <p
                className={styles.helpingDescription}
                style={{ fontSize: "0.9em" }}
              >
           
                <span style={{ color: "white", fontSize: "0.6em" }}>✦</span>{" "}
                Join our merchants.
             
              </p>

                   <Link to="/MerchantApp">
              <button
                className={styles.but}
                style={{
                  backgroundColor: "#fff",
                  color: "green",
                  border: "none",
                  padding: "15px 20px",
                  borderRadius: "10px",
                  fontSize: "10px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  marginTop: "20px",
                }}
              >
                Register Now →
              </button>
              </Link>
              
            </div>

            {/* Image Side */}
            <div
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={view} 
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Pricing;
